import { Component, computed, effect, NgZone, OnInit, signal } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { filter } from 'rxjs';
import { Loader } from './pages/loader/loader';
import { SignalrService } from './services/signalr.service';

@Component({
  selector: 'app-root',
  imports: [ReactiveFormsModule, RouterOutlet, Loader],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class App implements OnInit {
  title = 'orange-line';
  constructor(
    protected route: ActivatedRoute,
    private ngZone: NgZone,
    private router: Router,
    private signalrService: SignalrService,
  ) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      // ...existing code...
    });
  }

  ngOnInit(): void {
    // Start SignalR connection for the whole app
    this.signalrService.startConnection();
  }

  private saveLoginSession(response: any): void {}

  prepareRoute(outlet: RouterOutlet) {
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['animation'];
  }
}
